import React, { useState } from "react";

const Courses = () => {

  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
  });

  const programs = [
    {
      title: "Full Stack Web Development",
      duration: "6 Months",
      level: "Beginner to Advanced",
      points: [
        "HTML, CSS, JavaScript, React",
        "Node.js & MongoDB",
        "Live Projects",
        "Certificate Included",
      ],
    },
    {
      title: "Mobile App Development",
      duration: "4 Months",
      level: "Intermediate",
      points: [
        "React Native / Flutter",
        "Android & iOS Apps",
        "API Integration",
        "Project Based Training",
      ],
    },
    {
      title: "Digital Marketing",
      duration: "3 Months",
      level: "All Levels",
      points: [
        "SEO & Google Ranking",
        "Social Media Marketing",
        "Paid Ads",
        "Real Campaign Practice",
      ],
    },
    {
      title: "UI/UX Design",
      duration: "2 Months",
      level: "Beginner",
      points: [
        "Figma & Design Tools",
        "Wireframes & Prototypes",
        "User Experience Design",
        "Portfolio Projects",
      ],
    },
    {
      title: "E-Commerce Development",
      duration: "3 Months",
      level: "Intermediate",
      points: [
        "Online Store Setup",
        "Payment Gateway",
        "Admin Dashboard",
        "Live Website Project",
      ],
    },
    {
      title: "SEO & Content Strategy",
      duration: "2 Months",
      level: "Beginner",
      points: [
        "Keyword Research",
        "On-page & Off-page SEO",
        "Content Strategy",
        "Ranking Techniques",
      ],
    },
  ];

  const handleOpen = (course) => {
    setForm({ ...form, course });
    setOpen(true);
    setSuccess(false);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setTimeout(() => {
      setSuccess(true);
    }, 700);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-100 py-20 px-6">

      {/* HEADER */}
      <div className="text-center mb-20">
        <p className="text-red-600 uppercase tracking-widest text-sm font-semibold">
          Professional Training
        </p>

        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3">
          Industry-Oriented Training Programs
        </h2>

        <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
          Practical, job-ready courses designed for real-world skills.
        </p>

        <div className="w-24 h-1 bg-red-600 mx-auto mt-5 rounded-full"></div>
      </div>

      {/* CARDS (UNCHANGED) */}
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {programs.map((item, i) => (
          <div
            key={i}
            className="group bg-white rounded-3xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100"
          >

            <h3 className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition">
              {item.title}
            </h3>

            <div className="mt-3 flex justify-between text-sm text-gray-500">
              <span>⏳ {item.duration}</span>
              <span>📊 {item.level}</span>
            </div>

            <ul className="mt-5 space-y-2 text-sm text-gray-600">
              {item.points.map((point, index) => (
                <li key={index}>✔ {point}</li>
              ))}
            </ul>

            <button
              onClick={() => handleOpen(item.title)}
              className="mt-6 w-full py-3 bg-red-600 text-white rounded-xl font-semibold hover:bg-red-700 transition shadow-md hover:shadow-lg"
            >
              Enroll Now →
            </button>

          </div>
        ))}
      </div>

      {/* SIDE PANEL */}
      {open && (
        <div className="fixed inset-0 z-50 flex">

          {/* OVERLAY */}
          <div
            className="flex-1 bg-black/50 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          ></div>

          {/* PANEL */}
          <div className="w-full max-w-md h-full p-8 relative animate-slideIn bg-white/90 backdrop-blur-xl shadow-2xl">

            {/* CLOSE */}
            <button
              onClick={() => setOpen(false)}
              className="absolute top-5 right-5 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>

            {!success ? (
              <>
                <div className="mb-8">
                  <p className="text-sm text-red-500 font-semibold">
                     Secure & Fast Registration
                  </p>

                  <h2 className="text-2xl font-bold text-gray-900 mt-1">
                    Enroll in Course
                  </h2>

                  <p className="text-gray-500 text-sm mt-1">
                    Fill your details
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">

                  <div className="relative">
                    <input
                      type="text"
                      name="name"
                      onChange={handleChange}
                      required
                      className="peer w-full border-b-2 border-gray-300 focus:border-red-500 outline-none py-2 bg-transparent"
                    />
                    <label className="absolute left-0 top-2 text-gray-400 text-sm transition-all 
                      peer-focus:-top-3 peer-focus:text-xs peer-focus:text-red-500 
                      peer-valid:-top-3 peer-valid:text-xs">
                      Your Name
                    </label>
                  </div>

                  <div className="relative">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      required
                      className="peer w-full border-b-2 border-gray-300 focus:border-red-500 outline-none py-2 bg-transparent"
                    />
                    <label className="absolute left-0 top-2 text-gray-400 text-sm transition-all 
                      peer-focus:-top-3 peer-focus:text-xs peer-focus:text-red-500 
                      peer-valid:-top-3 peer-valid:text-xs">
                      Your Email
                    </label>
                  </div>

                  <div className="relative">
                    <input
                      type="tel"
                      name="phone"
                      onChange={handleChange}
                      required
                      className="peer w-full border-b-2 border-gray-300 focus:border-red-500 outline-none py-2 bg-transparent"
                    />
                    <label className="absolute left-0 top-2 text-gray-400 text-sm transition-all 
                      peer-focus:-top-3 peer-focus:text-xs peer-focus:text-red-500 
                      peer-valid:-top-3 peer-valid:text-xs">
                      Phone Number
                    </label>
                  </div>

                  <div className="p-3 bg-gray-100 rounded-lg text-sm text-gray-700">
                    Selected Course: <span className="font-semibold">{form.course}</span>
                  </div>

                  <button
                    type="submit"
                    className="w-full py-3 rounded-full bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold hover:scale-[1.03] transition"
                  >
                    Continue →
                  </button>

                </form>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-center">

                <div className="w-24 h-24 rounded-full bg-gradient-to-r from-green-400 to-green-600 flex items-center justify-center text-white text-4xl shadow-lg animate-scale">
                  ✓
                </div>

                <h2 className="mt-6 text-2xl font-bold text-gray-900">
                  You're Enrolled!
                </h2>

                <p className="text-gray-500 mt-2">
                  Our team will contact you shortly.
                </p>

                <button
                  onClick={() => setOpen(false)}
                  className="mt-6 px-6 py-2 bg-black text-white rounded-full hover:bg-gray-800 transition"
                >
                  Done
                </button>

              </div>
            )}

          </div>
        </div>
      )}

      {/* ANIMATION */}
      <style>
        {`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }

        @keyframes scale {
          from { transform: scale(0); }
          to { transform: scale(1); }
        }

        .animate-slideIn {
          animation: slideIn 0.4s ease;
        }

        .animate-scale {
          animation: scale 0.4s ease;
        }
        `}
      </style>

    </div>
  );
};

export default Courses;